<template>
	<div id="top" style="padding-top: 72px">
		<head-nav @userInfo="getUserToken"></head-nav>
		<div class="top_banner">
			<img :src="imgAllPath('qz_banner.png')" class="banner_img" />
		</div>
		<div class="domConversionOfd_body" :class="isPhone == 'true' ? 'mobile' : ''">
			<div class="title">
				<span>在线验签</span>
			</div>
			<div class="s_title">
				<p style="display: inline-block; margin: 0">支持批量上传OFD文档，批量查验签名、签章、时间戳的有效性</p>
			</div>
			<div class="down-type" :class="{ active: isShow }">
				<uploader ref="uploader" :options="options" :autoStart="false" @file-added="onFileAdded"
					@files-submitted="onSubmitted" @file-progress="onFileProgress" class="uploader-app" v-if="!isShow">
					<uploader-unsupport></uploader-unsupport>
					<uploader-drop>
					<div class="uploader-btn btn btn-primary" v-if="!token"
						@click.prevent="loginBtn">选择文件</div>
					<uploader-btn id="global-uploader-btn" v-else class="uploader-btn btn btn-primary" :attrs="attrs"
						ref="uploadBtn">选择文件</uploader-btn>
					<p>点击或拖拽打开文件，文件总大小不超过10M。</p>
				</uploader-drop>
				</uploader>
				<tableTurn :isShowData="isShow" :fileListData="fileList" :attrsData="attrs.accept"
					:allUpLoadIngData="allUpLoadIng" @endTurn="endTurn" @AddUpload="AddUpload"
					:allzhSuccessEndData="allzhSuccessEnd"></tableTurn>
			</div>
			<!--   转换描述   -->
			<div class="advantage_desc">
				<div class="content_box">
					<div class="content" v-for="(item, index) in advantageDesc" :key="index">
						<img :src="imgAllPath(item.img)" class="content_img" />
						<p class="content_t">{{ item.title }}</p>
						<p class="content_d">{{ item.text }}</p>
					</div>
				</div>
			</div>
			<!-- 提示弹框 -->
			<el-dialog title="提示" :visible.sync="dialogFolder" class="changephone_box fail_box"
				:close-on-click-modal="false" width="420px" append-to-body>
				<div class="content">
					<h2>以下{{ gsErrorList.length + wkErrorList.length }}个文件添加失败！</h2>
					<div class="item_list" v-if="gsErrorList.length > 0">
						<h3>文件格式不匹配：</h3>
						<p v-for="(item, index) in gsErrorList" :key="index">
							<icon :type="1" :fileType="item.fileTypeCase" :isTable="true" :fileFail="false"
								:isSeach="true"></icon>
							<a :title="item.name + '.' + item.fileType">{{ item.name.length > 15 ? item.slname :
									item.name
							}}{{ "." + item.fileType }}</a>
						</p>
					</div>
					<div class="item_list" v-if="wkErrorList.length > 0">
						<h3>文件大小为空：</h3>
						<p v-for="(item, index) in wkErrorList" :key="index">
							<img src="@comm/images/document-conversion/kong_icon.svg" />
							<a :title="item.name + '.' + item.fileType">{{ item.name.length > 15 ? item.slname :
									item.name
							}}{{ "." + item.fileType }}</a>
						</p>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitFolder" size="mini">确 定</el-button>
				</div>
			</el-dialog>
		</div>
		<div class="foot_banner">
			<img :src="imgAllPath('banner4.png')" alt class="left" />
			<div class="right">
				<p class="right_t">支持全环境使用</p>
				<p class="right_p">适用于所有计算机，包括Mac、Windows及Linux。</p>
				<p class="right_p">在线兼容主流浏览器，如：火狐浏览器、Chrome浏览器、Safari浏览器、360浏览器、Microsoft Edge浏览器、IE10及以上版本等。</p>
			</div>
		</div>
		<customer-service :callUs="callUs" @callUs="getCallUs"></customer-service>
		<!--    footer -->
		<footer-nav></footer-nav>
	</div>
</template>

<script>
import SparkMD5 from "spark-md5";
import tableTurn from "./components/tableTurn.vue";
import { ACCEPT_CONFIG } from "@comm/utils/acceptFileType.js";
import { attestationUploadFile } from "@comm/api/document-conversion/attestation.js";
import footerNav from "@comm/components/document-conversion/footerPage";
import headNav from "@comm/components/document-conversion/headerPage";
import icon from "@comm/components/document-conversion/iconImg";
import customerService from "@comm/components/document-conversion/customerService";
import { getToken } from "@comm/utils/auth";
import common from "@comm/utils/common";
export default {
	components: {
		tableTurn,
		footerNav,
		icon,
		customerService,
		headNav
	},
	name: "attestationPage",
	data() {
		this.advantageDesc = [
			{
				img: "five.png",
				title: "批量验证，同步并行",
				text: "支持上传多个OFD文件批量完成验证，省时省力同步并行。"
			},
			{
				img: "six.png",
				title: "高速加载，快速响应",
				text: "多线程高速加载优化，签章验证结果快速响应，专业高效不用你等。"
			},
			{
				img: "ten.png",
				title: "批量筛查，精准定位",
				text: "OFD文件批量验签时，如其中包含有效、无效、未知等多种验证结果，可快速定位无效或未知签章文件，精准排查签章问题。"
			},
			{
				img: "night.png",
				title: "一文多签，详细展示",
				text: "当文档存在多个签章，查验后会分别显示每个签章的详情，包含具体的签章属性及签章人证书、制章人证书、有效期等。"
			},
			{
				img: "seven.png",
				title: "多种标准，可靠合规",
				text: "验证结果准确可靠，支持国密与非国密密码算法以及多种签章标准、签名标准，精准验证，值得信赖。"
			},
			{
				img: "eight.png",
				title: "隐私防护，无忧试用",
				text: "数科OFD在线批量验签注重用户文档隐私防护，全面阻断任何渠道访问您的文档。"
			}
		];
		return {
			fileList: [],
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { }
			},
			attrs: {
				accept: ACCEPT_CONFIG.getOfd()
			},
			isShow: false,
			upLoadType: 0,
			allUpLoadIng: false,
			newList: [],
			upTime: "",
			oldFileList: [],
			allzhSuccessEnd: false,
			dialogFolder: false,
			gsErrorList: [],
			cfErrorList: [],
			wkErrorList: [],
			isPhone: false,
			uploadList: [],
			uploadListLength: 0,
			callUs: false,
			token: null,
		};
	},
	created() {
	},
	mounted() {
		this.token = getToken()
		this.isPhone = localStorage.getItem("isPhone");
		let toElement = document.getElementById("top");
		document.title = "在线验签";
		//锚点存在跳转
		toElement.scrollIntoView() + 100;
		document.body.ondrop = function(event){
			event.preventDefault();
			event.stopPropagation();
		}
	},
	watch: {
		$route(to, from) {
			this.$router.go(0);
		},
		progress() {
			this.$refs.uploader.uploader && this.$refs.uploader.uploader.progress();
		},
		uploadList(val) {
			if (val.length > 0 && this.allUpLoadIng) {
				for (let index = 0; index < val.length; index++) {
					if (index <= 4) {
						this.uploadApi(index);
					}
				}
			}
		},
		uploadListLength(val) {
			if (this.uploadListLength + 5 <= this.uploadList.length) {
				this.uploadApi(this.uploadListLength + 4);
			}
		}
	},
	computed: {
		imgAllPath() {
			return function (img) {
				return require("@comm/images/document-conversion/onlinePreview/" + img);
			};
		},
	},
	methods: {
		getUserToken(data) {
			this.token = data.token
		},
		getCallUs(data) {
			this.callUs = data;
		},
		endTurn(data) {
			this.isShow = data.isShow;
			this.fileList = data.fileList;
			this.oldFileList = data.oldFileList ? data.oldFileList : this.oldFileList;
			if (data.isAllDel) {
				if (this.$refs.uploader) {
					this.$refs.uploader.uploader.cancel();
				}
			}
		},
		AddUpload(data) {
			this.oldFileList = data.fileList;
			this.allzhSuccessEnd = data.allzhSuccessEnd;
		},
		submitFolder() {
			this.dialogFolder = false;
			// if(if){
			//      this.allUpLoadIng=false
			//    }
			setTimeout(function () {
				this.gsErrorList = [];
				// this.cfErrorList = [];
				this.wkErrorList = [];
			}, 300);
		},
		loginBtn() {
			let path = `${this.$route.path}`;
			window.open(
				`https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
				"_self"
			);
		},
		onFileAdded(file, isReUpload, fileList) {
			this.allUpLoadIng = true;
			this.gsErrorList = [];
			// this.cfErrorList = [];
			this.wkErrorList = [];

			file.progress = 0;
			file.disable = true;
			file.wait = true;
			if (isReUpload) {
				this.fileList = fileList;
				this.uploadApi(file.index, isReUpload);
			}
		},
		onSubmitted(fileList) {
			this.uploadList = [];
			this.uploadListLength = 0;
			if (fileList.length <= 0) {
				return;
			}
			let sizeTotal = 0;
			let totalFileList = [];
			let oldZh = [];
			this.oldFileList.forEach((item) => {
				if (item.zhSuccess) {
					oldZh.push(item);
				}
			});
			if (oldZh.length > 0) {
				totalFileList = [...fileList];
			} else {
				totalFileList = [...this.oldFileList, ...fileList];
			}

			totalFileList.forEach((item) => {
				sizeTotal += +item.size;
			});

			const isLt = sizeTotal / 1024 / 1024 / 10 <= 1;
			if (!isLt) {
				this.allUpLoadIng = false;
				this.$confirm("您选择的文件总大小超过10M，请重新选择！", "", {
					cancelButtonText: "取消",
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "warning",
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					lockScroll: false
				}).then(() => {
					this.allUpLoadIng = false;
					// this.fileList=this.oldFileList
					// this.$refs.uploader.uploader.cancel();
					return;
				});
			} else {
				let index = 0;
				this.infoDetails(index, fileList);
			}
		},
		infoDetails(index, fileList) {
			let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
			let fileReader = new FileReader();
			let spark = new SparkMD5.ArrayBuffer();
			fileReader.readAsArrayBuffer(blobSlice.call(fileList[index].file, 0, fileList[index].size));
			// 开始读取文件内容
			// reader.readAsDataURL(fileList[index].file);
			// 读取操作结束时触发
			fileReader.onload = (e) => {
				fileList[index].fileHash = this.$sha256(e.target.result);
				spark.append(e.target.result);
				fileList[index].baseUrl = spark.end();
				if (index == fileList.length - 1) {
					let lng = 0;
					let okList = [];
					this.newList = [];
					fileList.forEach((item, indexs) => {
						this.newList.push(item);
						if (indexs == fileList.length - 1) {
							this.dealData(lng, okList, fileList);
						}
					});
				} else {
					index = index + 1;
					this.infoDetails(index, fileList);
				}
			};
		},
		dealData(lng, okList, fileList) {
			let file = this.newList[lng];
			let extName = "";
			let AllUpExt = ".ofd|";
			extName = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
			if (AllUpExt.indexOf(extName + "|") == "-1") {
				file.cancel();
				let index = file.name.lastIndexOf(".");
				file.fileType = file.name.substring(index + 1, file.name.length);
				file.fileTypeCase = file.fileType.toLowerCase();
				file.name = file.name.substring(0, index);
				let fileListArrayname = file.name;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					file.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				this.gsErrorList.push(file);
				// if(lng==fileList.length-1){
				//   this.allUpLoadIng = false;
				// }
				fileList.splice(lng, 1);
			} else if (file.size == 0) {
				file.cancel();
				let index = file.name.lastIndexOf(".");
				file.fileType = file.name.substring(index + 1, file.name.length);
				file.fileTypeCase = file.fileType.toLowerCase();
				file.name = file.name.substring(0, index);
				let fileListArrayname = file.name;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					file.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				this.wkErrorList.push(file);
				//         if(lng==fileList.length-1){
				//   this.allUpLoadIng = false;
				// }
				fileList.splice(lng, 1);
			} else {
				if (this.oldFileList.length > 0) {
					let nameLng = 1;
					let isReturn = false;

					for (var jj = 0; jj < this.oldFileList.length; jj++) {
						var list = this.oldFileList[jj];
						if (file.baseUrl == list.baseUrl && file.name == list.name + "." + list.fileType) {
							// this.$refs.uploader.uploader.cancel();
							isReturn = true;
							file.cancel();
							this.cfErrorList.push(file);

							fileList.splice(lng, 1);
							// if(lng==fileList.length){
							//   this.allUpLoadIng = false;
							// }
							// this.allUpLoadIng = false;
						} else if (file.name == list.name + "." + list.fileType && file.baseUrl != list.baseUrl) {
							let index = file.name.lastIndexOf(".");
							let fileNameSuffix = file.name.substring(0, index);
							let fileType = file.name.substring(index, file.name.length);
							var fileNameTmp = file.name.substring(0, index) + "(" + nameLng + ")";
							for (var i = 0; i < this.oldFileList.length; i++) {
								if (fileNameTmp == this.oldFileList[i].name) {
									fileNameTmp = fileNameSuffix + "(" + ++nameLng + ")";
									i = 0;
								}
							}
							file.name = fileNameTmp + fileType;
							okList.push(file);
							break;
						} else {
							if (this.oldFileList.length - 1 == jj && !isReturn) {
								okList.push(file);
								break;
							}
						}
					}

					// this.oldFileList.forEach((list) => {
					// });
				} else {
					okList.push(file);
				}
			}
			if (lng != this.newList.length - 1) {
				lng = lng + 1;
				this.dealData(lng, okList, fileList);
			} else {
				if (this.gsErrorList.length > 0 || this.wkErrorList.length > 0) {
					this.dialogFolder = true;
				}
				if (okList.length <= 0) {
					this.allUpLoadIng = false;
					return;
				}
				this.isShow = true;
				okList.forEach((item) => {
					item.isUpLoading = true;
					item.wait = true;
					var index = item.name.lastIndexOf(".");
					item.fileType = item.name.substring(index + 1, item.name.length);
					item.fileTypeCase = item.fileType.toLowerCase();
					item.name = item.name.substring(0, index);
				});
				this.fileList = okList;
				this.fileList.forEach((item) => {
					this.uploadList.push(item);
				});
			}
		},
		uploadApi(i, isReUpload) {
			let fileData = new FormData();
			fileData.append("file", this.fileList[i].file);
			this.fileList[i].wait = false;
			this.apiUpLoad(i, fileData, isReUpload);
		},
		apiUpLoad(i, fileData, isReUpload) {
			let that = this;
			attestationUploadFile(fileData)
				.then((res) => {
					if (!res.data) {
						this.uploadListLength = this.uploadListLength + 1;
						this.fileList[i].isUpLoading = false;
						this.fileList[i].cause = res.data.cause;
						if (this.uploadListLength == that.uploadList.length || isReUpload) {
							this.allUpLoadIng = false;

							return;
						}
					} else {
						this.uploadListLength = this.uploadListLength + 1;
						this.fileList[i].isUpLoading = false;
						this.fileList[i].fileConversionNeedDTO = res.data;
						this.fileList[i].upLoadSuccess = true;
						if (this.uploadListLength == this.uploadList.length || isReUpload) {
							this.allUpLoadIng = false;
							return;
						}
					}
				})
				.catch((err) => {
					this.uploadListLength = this.uploadListLength + 1;
					this.fileList[i].isUpLoading = false;
					this.fileList[i].cause = "上传失败";
					if (this.uploadListLength == that.uploadList.length || isReUpload) {
						this.allUpLoadIng = false;

						return;
					}
				});
		},
		onFileProgress() { }
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.top_banner {
		width: 100%;
		height: 100%;
		position: relative;
		.banner_img {
			width: 100%;
		}
	}
.advantage_desc {
	margin: 80px 0;

	.content_box {
		width: 1200px;
		display: flex;
		margin: 0 auto;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;

		.content {
			width: 389px;
			height: 252px;
			border-radius: 4px;
			border: 1px solid rgba(0, 0, 0, 0.08);
			padding: 29px 24px;
			margin-bottom: 16px;
			display: flex;
			flex-direction: column;
			align-items: center;

			.content_img {
				width: auto;
				height: 67px;
				margin-bottom: 20px;
			}

			.content_t {
				font-size: 18px;
				font-weight: 600;
				color: #383E45;
				line-height: 28px;
				margin-bottom: 16px;
			}

			.content_d {
				font-size: 16px;
				font-weight: 400;
				color: #8B97AF;
				line-height: 24px;
				text-align: center;
				word-break: break-all;
				word-wrap: break-word;
				white-space: pre-wrap;
				width: 100%;
			}
		}
	}
}

.foot_banner {
	width: 100%;
	height: 195px;
	background: linear-gradient(180deg, rgba(248, 250, 255, .8) 0%, rgba(245, 247, 255, .8) 100%);
opacity: 0.8;
	display: flex;
	justify-content: center;
	padding: 10px 0;

	.left {
		width: 260px;
		height: 153px;
		margin: 0 24px 0 25px;
	}

	.right {
		padding: 21px 36px 0 40px;
		position: relative;
		width: 890px;

		.right_t {
			margin-bottom: 8px;
			font-size: 28px;
			font-weight: 400;
			color: #383E45;
			line-height: 40px;
		}

		.right_p {
			font-size: 16px;
			font-weight: 400;
			color: #8b97af;
			line-height: 28px;
		}
	}

	.right::before {
		content: "";
		background: rgba(0, 0, 0, 0.08);
		width: 1px;
		height: 119px;
		position: absolute;
		left: 0;
		top: 29px;
	}
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/attestationPage/index.vue